const TYPES = {
  VISIT_LOCATION: 'VisitLocation',
  TAKE_LUNCH: 'TakeLunch',
  REFILL_VEHICLE: 'RefillVehicle',
}

export { TYPES }
